<template>
    <div :class="[
        'cz2__menu-item',
        'cz2__menu-item--' + (type || 'none')   ,
    ]">
        <div class='cz2__menu-item__inner'>
            <button @click.prevent="selectItem">
                <span class="cz2__menu-item__button-content">
                    <span class="cz2__menu-item__complete-indicator"></span>

                    <span v-if="type" :class="[
                        'cz2__menu-item__icon',
                        { 'cz2__menu-item__icon--selected': selected },
                    ]">
                        <span v-if="color" class="cz2__menu-item__icon-color" :style="{ backgroundColor: color }"></span>
                    </span>

                    <span class="cz2__menu-item__title">
                        {{title}}

                        <span v-if="description && description.length > 0" class="cz2__type__normal cz2__menu-item__description">
                            &mdash;

                            {{description}}
                        </span>
                    </span>

                    <!-- Indicators are disabled for now. -->
                    <span v-if="false && hasIndicator" class="cz2__menu-item__expand-indicator"></span>
                </span>
            </button>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__menu-item {
            position: relative;

            width: 105px;
            flex: 0 0 auto;

            @include respond-above(sm) {
                width: 100%;
                height: 64px;
            }

            button {
                display: block;

                width: 100%;

                border: none;
                background: transparent;

                text-align: left;

                @include respond-below(sm) {
                    height: auto;
                }
            }
        }

        .cz2__menu-item__button-content {
            display: flex;
            flex-direction: column;

            align-items: center;

            @include respond-above(sm) {
                flex-direction: row;
            }
        }

        .cz2__menu-item__description {
            display: none;

            @include respond-above(sm) {
                display: inline-block;

                font-size: 14px;
                font-weight: 400;
            }
        }

        .cz2__menu-item__icon {
            position: relative;
            display: block;

            width: 44px;
            height: 44px;

            @include respond-above(sm) {
                margin-right: 12px;
            }

            &.cz2__menu-item__icon--selected {
                &:after {
                    content: '';

                    display: block;
                    position: absolute;

                    width: 44px;
                    height: 44px;

                    border-radius: 44px;

                    border: 2px solid #000;
                }
            }
        }

        .cz2__menu-item__icon-color {
            display: block;
            position: absolute;

            width: 22px;
            height: 22px;

            border-radius: 22px;

            left: calc(50% - 11px);
            top: calc(50% - 11px);
        }

        .cz2__menu-item--product-info {
            .cz2__menu-item__icon {
                background: transparent url(../assets/menu-info@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item--color {
            .cz2__menu-item__icon {
                background: transparent url(../assets/menu-color@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item--side {
            .cz2__menu-item__icon {
                background: transparent url(../assets/menu-side@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item--images {
            .cz2__menu-item__icon {
                background: transparent url(../assets/menu-images@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item--text {
            .cz2__menu-item__icon {
                background: transparent url(../assets/menu-text@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item--monogram {
            .cz2__menu-item__icon {
                background: transparent url(../assets/menu-monogram@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item--group {
            .cz2__menu-item__icon {
                background: transparent url(../assets/menu-group@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item--help {
            .cz2__menu-item__icon {
                background: transparent url(../assets/menu-help@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item--side-front {
            .cz2__menu-item__icon {
                background: transparent url(../assets/design-front@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item--side-back {
            .cz2__menu-item__icon {
                background: transparent url(../assets/design-back@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item--side-front-back {
            .cz2__menu-item__icon {
                background: transparent url(../assets/design-front-back@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item--side-both {
            .cz2__menu-item__icon {
                background: transparent url(../assets/design-same@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item__title {
            max-width: 80px;
            max-height: 12px;

            margin-top: 10px;

            color: #000;

            font-family: $font-main;
            font-size: 10px;
            font-weight: 400;
            line-height: 12px;

            text-align: center;

            @include respond-above(sm) {
                flex: 1 0 auto;

                max-width: none;
                max-height: none;

                margin-top: 0;

                font-size: 16px;
                font-weight: 500;
                line-height: 22px;

                // DIN has an odd baseline and glyph height combo, so it doesn't center nicely automatically.
                position: relative;
                top: -2px;

                text-align: left;
            }
        }

        .cz2__menu-item__expand-indicator {
            display: none;

            @include respond-above(sm) {
                display: block;

                width: 8px;
                height: 13px;

                background: transparent url(../assets/arrow-small-right@2x.png) no-repeat center/contain;
            }
        }

        .cz2__menu-item.cz2__menu-item--full-width {
            width: 100%;
            height: 64px;

            .cz2__menu-item__button-content {
                flex-direction: row;
            }

            .cz2__menu-item__description {
                display: inline-block;

                font-size: 14px;
                font-weight: 400;
            }

            .cz2__menu-item__icon {
                margin-right: 12px;
            }

            .cz2__menu-item__title {
                flex: 1 0 auto;

                max-width: none;
                max-height: none;

                margin-top: 0;

                font-size: 16px;
                font-weight: 500;
                line-height: 22px;

                // DIN has an odd baseline and glyph height combo, so it doesn't center nicely automatically.
                position: relative;
                top: -2px;

                text-align: left;
            }

            .cz2__menu-item__expand-indicator {
                display: block;

                width: 8px;
                height: 13px;

                background: transparent url(../assets/arrow-small-right@2x.png) no-repeat center/contain;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: '',
            },
            type: {
                type: String,
                default: '',
            },
            description: {
                type: String,
                default: null,
            },
            color: {
                type: String,
                default: null,
            },
            hasIndicator: {
                type: Boolean,
                default: true,
            },
            selected: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            /**
             * Current selected step.
             */
            selectedStep() {
                return this.$store.state.selectedStep;
            },
        },
        methods: {
            /**
             * Enter selection mode if no item selected.
             */
            selectItem() {
                this.$emit('selected');
            },
        },
    };
</script>
